import { Backdrop } from '@mui/material';
import styled from 'styled-components';

// MUI modal z-index is 1300
export const StyledBackdrop = styled(Backdrop)`
  &.MuiBackdrop-root {
    z-index: 1301;
  }
`;
